module.exports = __webpack_public_path__ + "img/Airbnb-Equipment-Mobile-Devices.5f5bf3ba.jpg";